import axiosClient from './axiosClient';
export default {
  list: (params) => axiosClient.get('/scadenze', { params }),
  listbydocument: (documentId, params) => axiosClient.get(`/scadenze/listbydocument/${documentId}`, { params }),
  listbycontribuente: (contribuenteId, params) => axiosClient.get(`/scadenze/contribuente/${contribuenteId}`, { params }),
  listbycontribuenteandstato: (contribuenteId, params) => axiosClient.get(`/scadenze/bycontribuenteandstato/${contribuenteId}`, { params }),
  get: (id) => axiosClient.get(`/scadenze/${id}`),
  paga: (token) => axiosClient.get(`/scadenze/paga/${token}`), // ✅ nuova rotta pubblica
  setpagatamanuale: (id) => axiosClient.get(`/scadenze/${id}/setpagata`),
  create: (data) => axiosClient.post('/scadenze', data),
  update: (id, data) => axiosClient.put(`/scadenze/${id}`, data),
  delete: (id) => axiosClient.delete(`/scadenze/${id}`),
  uploadPdf: (id, formData) => axiosClient.post(`/scadenze/${id}/upload`, formData, { headers: {'Content-Type': 'multipart/form-data'} }),
};